import { buildingConstants } from '../_constants';
import { buildingService } from '../_services';
// import { alertActions } from '.';
// import { history } from '../_helpers';

export const buildingActions = {
    create,
    getById,
    getAll,
    getByPostalCode,
};

function create(values) {
    return dispatch => new Promise((resolve, reject) => {
        dispatch(request());
        buildingService.create(values)
            .then(
                (building) => {
                    dispatch(success(building));
                    resolve(building);
                },
                (error) => {
                    dispatch(failure(error.toString()));
                    reject(error);
                },
            );
    });

    function request() {
        return { type: buildingConstants.CREATE_REQUEST };
    }
    function success(building) {
        return { type: buildingConstants.CREATE_SUCCESS, building };
    }
    function failure(error) {
        return { type: buildingConstants.CREATE_FAILURE, error };
    }
}

function getById(id) {
    return (dispatch) => {
        dispatch(request());

        buildingService.getById(id)
            .then(
                building => dispatch(success(building)),
                error => dispatch(failure(error.toString())),
            );
    };

    function request() {
        return { type: buildingConstants.GETDETAIL_REQUEST };
    }
    function success(building) {
        return { type: buildingConstants.GETDETAIL_SUCCESS, building };
    }
    function failure(error) {
        return { type: buildingConstants.GETDETAIL_FAILURE, error };
    }
}

function getAll() {
    return (dispatch) => {
        dispatch(request());

        buildingService.getAll()
            .then(
                buildings => dispatch(success(buildings)),
                error => dispatch(failure(error.toString())),
            );
    };

    function request() {
        return { type: buildingConstants.GETALL_REQUEST };
    }
    function success(buildings) {
        return { type: buildingConstants.GETALL_SUCCESS, buildings };
    }
    function failure(error) {
        return { type: buildingConstants.GETALL_FAILURE, error };
    }
}
function getByPostalCode(postalCode) {
    return dispatch => new Promise((resolve, reject) => {
        dispatch(request());
        buildingService.getByPostalCode(postalCode)
            .then(
                (buildings) => {
                    dispatch(success(buildings));
                    resolve(buildings);
                },
                (error) => {
                    dispatch(failure(error.toString()));
                    reject(error);
                },
            );
    });

    function request() {
        return { type: buildingConstants.BYPOSTALCODE_REQUEST };
    }
    function success(buildings) {
        return { type: buildingConstants.BYPOSTALCODE_SUCCESS, buildings };
    }
    function failure(error) {
        return { type: buildingConstants.BYPOSTALCODE_FAILURE, error };
    }
}




// WEBPACK FOOTER //
// ./src/_actions/building.actions.js